/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PerfilEmpresaBancos { 
    banco?: string;
    cuenta?: string;
    tipo?: PerfilEmpresaBancos.TipoEnum;
}
export namespace PerfilEmpresaBancos {
    export type TipoEnum = 'ahorro' | 'corriente';
    export const TipoEnum = {
        Ahorro: 'ahorro' as TipoEnum,
        Corriente: 'corriente' as TipoEnum
    };
}


